import routerList from './routerList';
// 一维路由集合
const routerArr = () => {
    const routers = [];
    const routerListRender = list => {
        list.forEach(router => {
            const { routes } = router;
            routers.push(router);
            if (routes && routes.length) {
                routerListRender(routes);
            }
        });
    };
    routerListRender(routerList());
    return routers;
};
export default routerArr;
